



import ProjectPage from '../projectManagement/project.vue'
export default {
  name: 'projectODM',
  components: { ProjectPage },
}
